module.exports = __webpack_public_path__ + "static/media/AnthuriumImg.85969b13.webp";